module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/pescetarian__8529dad8680be91fb41fdbd65ad9395b.png";